import { AssessmentOverviewQuestionnaireItem } from '../sections/assessment-overview/questionnaire'
import { ADLNeedQuestionnaireItem } from '../sections/adls-needs/questionnaire'
import { ResumptionOverviewQuestionnaireItem } from '../sections/resumption-overview/questionnaire'
import { SupervisoryReviewQuestionnaireItem } from '../sections/supervisory-review/questionnaire'
import { VitalsQuestionnaireItem } from '../sections/vitals/questionnaire'
import { VisitSchedulingQuestionnaireItem } from '../sections/visit-scheduling/questionnaire'
import { MedicalBackgroundQuestionnaireItem } from '../sections/medical-background/questionnaire'
import { SkilledNeedsQuestionnaireItem } from '../sections/skilled-needs/questionnaire'
import { DischargePlanningQuestionnaireItem } from '../sections/discharge-planning/questionnaire'
import { FinalStepsQuestionnaireItem } from '../sections/final-steps/questionnaire'
import { NarrativeQuestionnaireItem } from '../sections/narrative/questionnaire'

const RocAssessmentQuestionnaireItemCore = {
  // Authorizations
  AUTHORIZATION: 'authorization',
  AUTHORIZATION_AUTHORIZATION: 'authorization/authorization',
  AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE:
    'authorization/authorization/authorization-source',
  AUTHORIZATION_AUTHORIZATION_CURRENT_HOURS: 'authorization/authorization/current-hours',

  // Plan of care
  PLAN_OF_CARE: 'plan-of-care',
  PLAN_OF_CARE_GOALS: 'plan-of-care/goals',
  PLAN_OF_CARE_GOALS_GOAL: 'plan-of-care/goals/goal',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS: 'plan-of-care/patient-interventions',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO:
    'plan-of-care/patient-interventions/intervention-info',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INTERVENTION:
    'plan-of-care/patient-interventions/intervention-info/intervention',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_CATEGORY:
    'plan-of-care/patient-interventions/intervention-info/category',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_GOAL:
    'plan-of-care/patient-interventions/intervention-info/goal',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TASK:
    'plan-of-care/patient-interventions/intervention-info/task',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INDICATION:
    'plan-of-care/patient-interventions/intervention-info/indication',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TYPE:
    'plan-of-care/patient-interventions/intervention-info/type',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INSTRUCTION:
    'plan-of-care/patient-interventions/intervention-info/instruction',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_PATIENT_CENTERED_GOAL:
    'plan-of-care/patient-interventions/intervention-info/patient-centered-goal',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_ADDITIONAL_DETAILS:
    'plan-of-care/patient-interventions/intervention-info/additional-details',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_VISITS:
    'plan-of-care/patient-interventions/intervention-info/visits',
  PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_FREQUENCY:
    'plan-of-care/patient-interventions/intervention-info/frequency',

  // Medications
  MEDICATIONS: 'medications',
  MEDICATIONS_MEDICATION_LIST: 'medications/medication-list',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO: 'medications/medication-list/medication-info',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DRUGBANK_PCID:
    'medications/medication-list/medication-info/drugbank-product-concept-id',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_NAME:
    'medications/medication-list/medication-info/name',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_ROUTE:
    'medications/medication-list/medication-info/route',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_STRENGTH_NUMBER:
    'medications/medication-list/medication-info/strength-number',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_STRENGTH_UNIT:
    'medications/medication-list/medication-info/strength-unit',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INDICATIONS:
    'medications/medication-list/medication-info/indications',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_FREQUENCY:
    'medications/medication-list/medication-info/frequency',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DOSAGE_NUMBER:
    'medications/medication-list/medication-info/dosage-number',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DOSAGE_UNIT:
    'medications/medication-list/medication-info/dosage-unit',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INSTRUCTIONS:
    'medications/medication-list/medication-info/instructions',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_USAGE_STATUS:
    'medications/medication-list/medication-info/usage-status',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_START_DATE:
    'medications/medication-list/medication-info/start-date',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DISCONTINUE_DATE:
    'medications/medication-list/medication-info/discontinue-date',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_CONTROLLED:
    'medications/medication-list/medication-info/controlled',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_LIQUID:
    'medications/medication-list/medication-info/liquid',
  MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INFECTION:
    'medications/medication-list/medication-info/infection',
  MEDICATIONS_MEDICATION_SUMMARY: 'medications/medication-summary'
} as const

export const RocAssessmentQuestionnaireItem = {
  ...SkilledNeedsQuestionnaireItem,
  ...RocAssessmentQuestionnaireItemCore,
  ...SupervisoryReviewQuestionnaireItem,
  ...AssessmentOverviewQuestionnaireItem,
  ...VitalsQuestionnaireItem,
  ...ADLNeedQuestionnaireItem,
  ...DischargePlanningQuestionnaireItem,
  ...VisitSchedulingQuestionnaireItem,
  ...ResumptionOverviewQuestionnaireItem,
  ...MedicalBackgroundQuestionnaireItem,
  ...FinalStepsQuestionnaireItem,
  ...NarrativeQuestionnaireItem
} as const

export type RocAssessmentQuestionnaireItem =
  (typeof RocAssessmentQuestionnaireItem)[keyof typeof RocAssessmentQuestionnaireItem]
